<div class="dialog">
  <div class="header">
    <div class="text">
      <span class="title">{{ data.title }}</span>
      <span class="message">{{ data.message }}</span>
    </div>
    <mat-icon matRipple class="close" svgIcon="close" (click)="dialogRef.close()"></mat-icon>
  </div>

  <div class="content">
    <img class="image" [src]="data.image" (click)="navigateUrl()" />
  </div>

  <div class="bottom">
    <input
      id="check"
      type="checkbox"
      style="cursor: pointer"
      placeholder="não mostrar novamente"
      [checked]="esconderVideo"
      (change)="changeNaoMostrarNovamente()"
    />
    <label for="check" class="label-intro-input" style="cursor: pointer"
      >não mostrar novamente</label
    >
  </div>
</div>
